/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum GridFiltersApplyMode {
    ApplyToGridFilters = 'ApplyToGridFilters',
    ApplyToInitialState = 'ApplyToInitialState',
}
